<div class="main-content content-with-side-menu">
    <h1 class="page-header">
        <app-go-back [overrideBack]="true" (onGoBack)="goBack()"></app-go-back>
        {{ "PurchaseDetails.title" | translate }}
    </h1>

    @if (purchase) {
        <div
            class="purchase-details"
            [ngClass]="{ loading: waitingForPaymentProcessorConfirmation }"
        >
            @if (waitingForPaymentProcessorConfirmation) {
                <bcu-local-spinner
                    [size]="25"
                    [visible]="waitingForPaymentProcessorConfirmation"
                ></bcu-local-spinner>
            }
            <app-purchase-info hznTestId="purchase-details-info" [purchase]="purchase"></app-purchase-info>
            <div class="voffset-10">
                <app-acquired-sessions
                    hznTestId="purchase-details-sessions"
                    [purchase]="purchase"
                ></app-acquired-sessions>
            </div>
            <div class="voffset-10">
                <app-refunded-sessions
                    hznTestId="purchase-details-refunded-sessions"
                    [purchase]="purchase"
                ></app-refunded-sessions>
            </div>
            <div class="voffset-10">
                <app-payment-details
                    [purchase]="purchase"
                ></app-payment-details>
            </div>
            @if (!isRefunded) {
                <div
                    class="voffset-10"
                    [bcShowIfPrivilegeDynamic]="'Camps.campsCanManagePayments'"
                >
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">
                                {{ "PurchaseDetails.actions" | translate }}
                            </h5>
                            <div class="card-text">
                                @if (!purchase.isModification) {
                                    <span
                                        class="btn btn-danger"
                                        hznTestId="purchase-details-cancel-and-refund"
                                        (click)="fullRefund()"
                                        >{{
                                            "PurchaseDetails.cancelAndRefund"
                                                | translate
                                        }}</span
                                    >
                                }
                                @if (isPartialRefundPossible) {
                                    <span
                                        hznTestId="purchase-details-edit"
                                        (click)="onEdit()"
                                        class="btn btn-primary min-width-130 hoffset-10"
                                        >{{
                                            "PurchaseDetails.edit" | translate
                                        }}</span
                                    >
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    }
</div>
